import http from '../interceptors/Intercepter';

export const retrieveReviews = async (username) => {
  try {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };

    const params = {
      username: username,
    };

    const { data } = await http.get('/api/review/viewAll', { params, ...config });

    return [data, null];
  } catch (error) {
    return [null, error];
  }
};

export const createReview = async (username, reviewVo) => {
  try {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };

    const params = {
      username: username,
    };

    const { data } = await http.post('/api/review/create', reviewVo, { params, ...config });

    return [data, null];
  } catch (error) {
    return [null, error];
  }
};

export const viewReview = async (username, reviewExternalReference) => {
  try {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };

    const queryParams = new URLSearchParams({
      reviewExternalReference: reviewExternalReference,
      username: username,
    }).toString();

    const { data } = await http.get(`/api/review/view?${queryParams}`, config);

    return [data, null];
  } catch (error) {
    return [null, error];
  }
};

export const updateReview = async (username, reviewVo) => {
  try {
    const config = {
      headers: {
        'Content-Type': 'application/json',
      },
    };

    const params = {
      username: username,
    };

    const { data } = await http.put('/api/review/update', reviewVo, { params, ...config });

    return [data, null];
  } catch (error) {
    return [null, error];
  }
};
